import { render, staticRenderFns } from "./refund-policy-kr.component.vue?vue&type=template&id=b9514d84&scoped=true"
import script from "./refund-policy-kr.component.ts?vue&type=script&lang=ts&external"
export * from "./refund-policy-kr.component.ts?vue&type=script&lang=ts&external"
import style0 from "./refund-policy-kr.component.vue?vue&type=style&index=0&id=b9514d84&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9514d84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9514d84')) {
      api.createRecord('b9514d84', component.options)
    } else {
      api.reload('b9514d84', component.options)
    }
    module.hot.accept("./refund-policy-kr.component.vue?vue&type=template&id=b9514d84&scoped=true", function () {
      api.rerender('b9514d84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/refundPolicy/refund-policy-kr.component.vue"
export default component.exports